<template>
  <j-modal
    :title="title"
    width="60%"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': !disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('节点类型')">
                <j-dict-select-tag v-model="queryParam.nodeType" :placeholder="$t('请选择节点类型')" dictCode="node_type" />
                <!-- <a-select v-model="queryParam.nodeType" placeholder="请选择节点名称">
                  <a-select-option v-for="item in list" :value="item.code" :key="item.code">{{
                    item.name
                  }}</a-select-option>
                </a-select> -->
              </a-form-item>
            </a-col>
            <a-col :xl="10" :lg="10" :md="10" :sm="24">
              <a-form-item :label="$t('时间范围')">
                <a-range-picker
                  :show-time="true"
                  v-model="date"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="$t('请选择时间范围')"
                  style="width: 100%"
                  @change="onDateRangeChange"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                <a-button type="primary" @click="getData" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-row :gutter="24">
        <a-col :span="24">
          <div id="chart" style="width: 100%; height: 300px"></div>
        </a-col>
      </a-row>
    </a-spin>
  </j-modal>
</template>
    
    <script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JSearchSelectTag from '../../../../components/dict/JSearchSelectTag.vue'
import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import echarts from 'echarts'
import moment from 'moment'
export default {
  name: 'modal',
  components: {
    JSearchSelectTag,
  },
  data() {
    return {
      filterDictTextByCache: filterDictTextByCache,
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      url: {
        edit: '/jeecg-gis/nodeIotConfig/add',
        getIotDataCurve: '/jeecg-gis/nodeIotConfig/getIotDataCurve',
      },
      iotModel: {},
      date: [],
      queryParam: {
        begin: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
        end: moment().format('YYYY-MM-DD HH:mm:ss'),
      },
    }
  },
  computed: {
    title() {
      return this.$t('历史数据曲线图')
    },
    // i18n：校验规则使用 computed 以响应语言切换
    validatorRules() {
      return {
        deviceId: [{ required: true, message: this.$t('请选择物联设备') }],
        conversionCoefficient: [{ required: true, message: this.$t('请输入转换系数') }],
        remark: [{ required: true, message: this.$t('请输入备注') }],
      }
    },
  },
  methods: {
    onDateRangeChange(e) {
      if (e.length > 0) {
        this.queryParam.begin = e[0]
        this.queryParam.end = e[1]
      } else {
        delete this.queryParam.begin
        delete this.queryParam.end
      }
    },
    setChartData(data) {
      let xdata = []
      let ydata = []
      data.curveDataList.map(item=>{
        xdata.push(item.time)
        ydata.push(item.value)
      })
      var chart = document.getElementById('chart')
      var myChart = echarts.init(chart)
      var option = {
        // title: {
        //   text: `${this.model.groupName} ${this.model.resultType == 1 ? '本底' : '效率'} 质控`,
        //   left: 'center',
        // },
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '20%',
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
            },
            dataView: { readOnly: false },
            magicType: { type: ['line', 'bar'] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xdata,
          splitLine: {
            // X轴网格线
            show: true,
            lineStyle: {
              color: '#999',
              type: 'dashed',
            },
          },
        },
        yAxis: {
          type: 'value',
          min: data.min,
          max: data.max,
          splitLine: {
            // Y轴网格线
            show: true,
            lineStyle: {
              color: '#999',
              type: 'dashed',
            },
          },
        },
        dataZoom: [
          {
            type: 'inside',
          },
          {
            type: 'slider',
          },
        ],
        series: [
          {
            // name: 'Highest',
            type: 'line',
            data: ydata,
          },
        ],
      }
      myChart.setOption(option)
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    searchReset(){
        this.queryParam.begin = moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss');
        this.queryParam.end = moment().format('YYYY-MM-DD HH:mm:ss');
        this.date = [this.queryParam.begin, this.queryParam.end]
        this.getData();
    },
    getData() {
        if(this.queryParam.begin && this.queryParam.end){
            let params = {
              deviceId: this.queryParam.deviceId,
              nodeType: this.queryParam.nodeType,
              begin: this.queryParam.begin,
              end: this.queryParam.end,
            }
            postAction(this.url.getIotDataCurve, params).then(res => {
              if (res.success) {
                this.setChartData(res.result)
              } else {
                this.$message.error(res.message)
              }
            })
        }else{
            this.$message.warning(this.$t('请选择时间范围！'));
            return;
        }
    },
    init(row) {
      this.visible = true
      this.model = JSON.parse(JSON.stringify(row))
      this.queryParam = {
        deviceId: row.nodeIotConfig.deviceId,
        nodeType: row.node.type,
        begin: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
        end: moment().format('YYYY-MM-DD HH:mm:ss'),
      }
      this.date = [this.queryParam.begin, this.queryParam.end];
      this.$nextTick(() => {
        this.getData()
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    handleOk() {},
  },
}
</script>